import { Typography } from '@sunwebgroup/ui-components/uds'
import styled from 'styled-components'
import { Bar } from './Bar'

interface ScoreBarProps {
  score?: number
  label: string
}

const TypographyWrapper = styled.div`
  min-width: 102px;
`

export function ScoreBar({ score, label }: ScoreBarProps) {
  return (
    <>
      <TypographyWrapper>
        <Typography $variant="body-m-regular-tight">{label}</Typography>
      </TypographyWrapper>
      <Bar score={score || 0} />
    </>
  )
}
